
import type { PerformanceCore } from './performanceCore';

/**
 * Tracks resource loading performance metrics
 */
export class PerformanceResourceTracker {
  private core: PerformanceCore;
  
  constructor(core: PerformanceCore) {
    this.core = core;
  }
  
  trackResourceTiming(entry: PerformanceResourceTiming) {
    try {
      // Only track resources that took longer than 500ms to load
      if (entry.duration > 500) {
        // Extract file extension or resource type
        const url = new URL(entry.name);
        const pathParts = url.pathname.split('.');
        const fileExtension = pathParts.length > 1 ? pathParts.pop()?.toLowerCase() : 'unknown';
        
        // Categorize by resource type
        let resourceType = fileExtension;
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(fileExtension || '')) {
          resourceType = 'image';
        } else if (['js', 'mjs'].includes(fileExtension || '')) {
          resourceType = 'script';
        } else if (['css'].includes(fileExtension || '')) {
          resourceType = 'style';
        }
        
        // Only attempt to track if core is properly initialized
        if (this.core && typeof this.core.trackPerformanceEvent === 'function') {
          this.core.trackPerformanceEvent({
            category: 'performance', // Add the required category property
            action: 'slow_resource',
            label: resourceType || entry.initiatorType,
            value: Math.round(entry.duration),
            metadata: {
              url: entry.name,
              fileName: url.pathname.split('/').pop() || entry.name,
              duration: entry.duration,
              initiatorType: entry.initiatorType,
              size: entry.transferSize || 0,
              type: resourceType
            }
          });
        } else {
          console.warn('Performance core not initialized properly, cannot track resource timing');
        }
      }
    } catch (error) {
      console.error('Error tracking resource timing:', error);
    }
  }
}
